module.exports = __webpack_public_path__ + "static/media/text-category-icon.c6761ebe.svg";